import { createApp } from "vue";
import App from "./App.vue";
import "./index.css";
import "./assets/tailwind.css";

createApp(App).mount("#app");
